export default __webpack_public_path__ + "static/media/beauty_banner.72d9f551.jpg";